import React from 'react'
import { Admin } from '../../../../models';
import Button from '@mui/material/Button';
import Box from '@mui/material/Box';
import { reduxForm } from 'redux-form';
import FormBuilder, { IMedAppFormField } from '../../../form';
import { required, minLength, email } from '../../../form/utils/validations';
import { useDispatch, useSelector } from 'react-redux';
import { selectCreatingModel } from '../../store/selectors';
import { createModel } from '../../store/actions';
import LinearProgress from '@mui/material/LinearProgress';
import Typography from "@mui/material/Typography";

import { putMessage } from '../../../app/store/actions';


const OrganizationCreateForm: React.FC<any> = ({ mFields, name, handleSubmit, onSubmit }) => {

    const handleSubmitCallback = (value: any) => {
        onSubmit(value);
    };
    return (
        <form onSubmit={handleSubmit(handleSubmitCallback)}>  <FormBuilder fields={mFields} name={name} />
            <Button type="submit" variant="contained">Continue</Button>
        </form>);
}
 

const OrganizationCreateReduxForm = reduxForm<any, any>({
    form: 'organization-create',
})(OrganizationCreateForm);



const AddOrganization: React.FC<{admin?: Admin}> = ({admin}) => {
    
    const fields: IMedAppFormField[] = [
        {
            name: 'organizationName',
            label: 'Name',
            type: 'text',
            validate: [required, minLength(2)],

        },
        {
            name: 'organizationEmail',
            label: 'Email Address',
            type: 'email',
            validate: [email, required],

        },

 
        
    ];
    const dispatch = useDispatch();
    const creating = useSelector(selectCreatingModel('organization'));

    const handleSubmit = (value: any) => {
        if(admin?.organization) {
            dispatch(putMessage({type: 'error', message: 'Invalid action, this admin is already part of an organization'}))
            return;
        }
        const data = {...value, admin: admin?.id, isOrg: !!admin, Status: 1}

        dispatch(createModel({
            model: data,
            modelName: 'organization',
        }));

        
    }


  return (
    <Box style={{
        width: '100%'
    }}>
        <Box sx={{
            width: '70%',
            maxWidth: '700px',
            minWidth: '250px',
            marginLeft: '1em'
        }}>
            {(creating) && <LinearProgress />}
            <Typography variant="h6" noWrap fontWeight={700}>
             Create Organization
          </Typography>
    
        {  admin && (<Box bgcolor={'rgba(255, 144, 67, 0.1)'} padding={'15px'}>
                <Typography color={'#FF9043'}><b>{admin.Name}</b> will be the owner</Typography>
            </Box>)}
            <OrganizationCreateReduxForm mFields={fields} namel="kosy-2-org" onSubmit={handleSubmit} />
         
        </Box>
    </Box>
  )
}

export default AddOrganization;